/**
 * Minimal, dependency-free data table.
 * @param {{columns: Array<{key:string, header:string, render?:(row:any)=>React.ReactNode}>, rows: Array<any>, emptyLabel?: string, loading?: boolean}} props
 */
export default function DataTable({ columns, rows, emptyLabel = 'No data', loading = false }) {
  return (
    <div className="aq-table-wrap">
      <table className="aq-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key}>{col.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={columns.length} className="aq-table-empty">
                Loading…
              </td>
            </tr>
          ) : rows.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="aq-table-empty">
                {emptyLabel}
              </td>
            </tr>
          ) : (
            rows.map((row, i) => (
              <tr key={row.id || row.symbol || i}>
                {columns.map((col) => (
                  <td key={col.key} className={col.numeric ? 'num' : ''}>
                    {col.render ? col.render(row) : row[col.key]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
